export default {
  HOME: "होम",
  QUICK_QUIZ: "प्रश्नोत्तरी",
  SKIP: "छोड़ें",
};